<template>
  <div class="row">
    <!-- LEFT: My Projects -->
    <div class="col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
          >
            <h5>Projects</h5>
            <!-- <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border-0 dropdown-toggle border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Ongoing Projects
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="showAllProjects = true"
                  >
                    All Projects
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="showAllProjects = false"
                  >
                    Ongoing Projects
                  </a>
                </li>
              </ul>
            </div> -->
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div
              class="col-md-6"
              v-for="project in displayedProjects"
              :key="project.id"
            >
              <div class="card mb-4 shadow-none mb-md-0">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between mb-3"
                  >
                    <h6 class="text-truncate" :title="project.name">
                      {{ project.name }}
                    </h6>
                    <!-- <div class="dropdown">
                      <a
                        href="javascript:void(0);"
                        class="d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i class="ti ti-dots-vertical"></i>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_task"
                          >
                            <i class="ti ti-edit me-2"></i>Edit
                          </a>
                        </li>
                        <li>
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_modal"
                          >
                            <i class="ti ti-trash me-2"></i>Delete
                          </a>
                        </li>
                      </ul>
                    </div> -->
                  </div>

                  <div>
                    <!-- Leader -->
                    <div class="d-flex align-items-center mb-3">
                      <a href="javascript:void(0);" class="avatar">
                        <img
                          v-if="project.leader_avatar"
                          :src="project.leader_avatar"
                          class="img-fluid rounded-circle"
                          alt="Leader"
                        />
                        <span
                          v-else
                          class="avatar bg-soft-primary rounded-circle d-flex align-items-center justify-content-center"
                        >
                          <i class="ti ti-user text-primary fs-16"></i>
                        </span>
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-normal text-truncate">
                          <a
                            href="javascript:void(0);"
                            :title="project.leader_name"
                          >
                            {{ project.leader_name || "Project Leader" }}
                          </a>
                        </h6>
                        <span class="fs-13 d-block">Project Leader</span>
                      </div>
                    </div>

                    <!-- Deadline -->
                    <div class="d-flex align-items-center mb-3">
                      <a
                        href="javascript:void(0);"
                        class="avatar bg-soft-primary rounded-circle"
                      >
                        <i class="ti ti-calendar text-primary fs-16"></i>
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-normal">
                          {{ project.deadline || "No deadline" }}
                        </h6>
                        <span class="fs-13 d-block">Deadline</span>
                      </div>
                    </div>

                    <!-- Task counts + team avatars -->
                    <div
                      class="d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded p-2 mb-3"
                    >
                      <div class="d-flex align-items-center">
                        <span
                          class="avatar avatar-sm bg-success-transparent rounded-circle me-1"
                        >
                          <i class="ti ti-checklist fs-16"></i>
                        </span>
                        <p class="mb-0">
                          Tasks :
                          <span class="text-gray-9">
                            {{ project.completed_tasks ?? 0 }}
                          </span>
                          /{{ project.total_tasks ?? 0 }}
                        </p>
                      </div>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span
                          v-for="(avatar, idx) in project.team_avatars"
                          :key="idx"
                          class="avatar avatar-rounded"
                        >
                          <img
                            v-if="avatar"
                            class="border border-white"
                            :src="avatar"
                            alt="Member"
                          />
                        </span>
                        <a
                          v-if="project.extra_team_count > 0"
                          class="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium"
                          href="javascript:void(0);"
                        >
                          +{{ project.extra_team_count }}
                        </a>
                      </div>
                    </div>

                    <!-- Time spent (using total_hours as placeholder) -->
                    <div
                      class="bg-soft-secondary p-2 rounded d-flex align-items-center justify-content-between"
                    >
                      <p class="text-secondary mb-0 text-truncate">
                        Time Spent
                      </p>
                      <h5 class="text-secondary text-truncate">
                        {{ project.total_hours || "0" }}
                        <span class="fs-14 fw-normal">Hrs</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- If no projects -->
            <div
              v-if="!displayedProjects.length && !projectsLoading"
              class="col-12"
            >
              <p class="text-muted mb-0">No projects assigned to you yet.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT: My Tasks -->
    <div class="col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
          >
            <h5>Tasks</h5>
            <!-- <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border-0 dropdown-toggle border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                All Projects
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    All Projects
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    Ongoing Projects
                  </a>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
        <div class="card-body">
          <div class="list-group list-group-flush">
            <!-- Task item -->
            <div
              v-for="task in myTasks"
              :key="task.id"
              class="list-group-item border rounded mb-3 p-2"
            >
              <div class="row align-items-center row-gap-3">
                <div class="col-md-8">
                  <div
                    class="todo-inbox-check d-flex align-items-center"
                    :class="{ 'todo-strike-content': isTaskCompleted(task) }"
                  >
                    <span><i class="ti ti-grid-dots me-2"></i></span>

                    <!-- Checkbox -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="isTaskCompleted(task)"
                        :disabled="
                          isTaskCompleted(task) || completingId === task.id
                        "
                        @change="toggleTask(task)"
                      />
                    </div>

                    <!-- Priority star -->
                    <span class="me-2 d-flex align-items-center rating-select">
                      <i
                        class="ti"
                        :class="
                          task.priority === 'High'
                            ? 'ti-star-filled filled'
                            : 'ti-star'
                        "
                      ></i>
                    </span>

                    <!-- Title -->
                    <div class="strike-info">
                      <h4 class="fs-14 text-truncate" :title="task.title">
                        {{ task.title }}
                      </h4>
                      <small class="text-muted" v-if="task.project_name">
                        {{ task.project_name }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3"
                  >
                    <!-- Status badge -->
                    <span :class="statusBadgeClass(task.status)" class="me-2">
                      <i class="fas fa-circle fs-6 me-1"></i>
                      {{ prettyStatus(task.status) }}
                    </span>

                    <!-- Assignees (for my tasks this will usually be me + others) -->
                    <div class="d-flex align-items-center">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span
                          v-for="(avatar, idx) in task.assignee_avatars"
                          :key="idx"
                          class="avatar avatar-rounded"
                        >
                          <img
                            v-if="avatar"
                            class="border border-white"
                            :src="avatar"
                            alt="Assignee"
                          />
                        </span>
                        <span
                          v-if="task.assignee_extra > 0"
                          class="avatar avatar-rounded"
                        >
                          <span class="border border-white fs-12">
                            +{{ task.assignee_extra }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div
              v-if="!myTasks.length && !tasksLoading"
              class="list-group-item border-0 p-0"
            >
              <p class="text-muted mb-0">No tasks assigned to you yet.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useProjectStore } from "@/stores/projectStore";
import { useTaskStore } from "@/stores/taskStore";

const projectStore = useProjectStore();
const taskStore = useTaskStore();

const showAllProjects = ref(false);
const completingId = ref(null);

const projectsLoading = computed(() => projectStore.loading);
const tasksLoading = computed(() => taskStore.loading);

// Limit projects to a reasonable count (for dashboard widget)
const myProjects = computed(() => projectStore.items || []);
const displayedProjects = computed(() => {
  // For now just limit to first 2, you can change this logic easily
  return myProjects.value.slice(0, 5);
});

// Limit tasks to a few recent ones
const myTasks = computed(() => taskStore.items.slice(0, 5));

function isTaskCompleted(task) {
  return task.status === "Completed";
}

function prettyStatus(status) {
  switch (status) {
    case "Pending":
      return "Pending";
    case "Inprogress":
      return "In progress";
    case "Onhold":
      return "On hold";
    case "Completed":
      return "Completed";
    default:
      return status || "Pending";
  }
}

function statusBadgeClass(status) {
  switch (status) {
    case "Pending":
      return "badge badge-secondary-transparent d-flex align-items-center";
    case "Inprogress":
      return "badge bg-transparent-purple d-flex align-items-center";
    case "Onhold":
      return "badge bg-soft-pink d-inline-flex align-items-center";
    case "Completed":
      return "badge badge-soft-success align-items-center";
    default:
      return "badge bg-secondary d-inline-flex align-items-center";
  }
}

async function toggleTask(task) {
  if (isTaskCompleted(task)) return; // already completed

  try {
    completingId.value = task.id;
    await taskStore.complete(task.id);
  } finally {
    completingId.value = null;
  }
}

onMounted(async () => {
  // Sequential on shared hosting: parallel API bursts exhaust MySQL max_user_connections.
  await projectStore.list({
    scope: "me",
    status: "Active",
    per_page: 6,
  });
  await taskStore.list({
    scope: "me",
    per_page: 10,
  });
});
</script>
